export function pickTemplateIdFromParams(
  value: string | string[] | undefined
): string | undefined {
  if (typeof value === 'string' && value.length > 0) return value;
  if (Array.isArray(value) && value[0] && value[0].length > 0) return value[0];
  return undefined;
}
